// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dUfU","content":"styles_content__1QWCx"};